<script>
import FooterView from "@/views/FooterView.vue";
import HeaderView from "@/views/HeaderView.vue";
export default {
  components: {
    HeaderView,
    FooterView,
  },
};
</script>

<template>
  <HeaderView />
  <slot />
  <FooterView />
</template>
